/**
 * I18nForm — helper component for editing multilingual fields.
 * Renders a tab-bar with EN / 简体中文 / 繁體中文 / 日本語 tabs.
 *
 * Usage:
 *   <I18nForm
 *     label="Title"
 *     fieldName="title"
 *     value={form.title}         // { en, 'zh-CN', 'zh-TW', ja }
 *     onChange={(val) => setForm(f => ({ ...f, title: val }))}
 *     multiline={false}
 *   />
 */
import React, { useState } from 'react';

const LANGS = [
  { key: 'en',    label: 'EN' },
  { key: 'zh-CN', label: '简中' },
  { key: 'zh-TW', label: '繁中' },
  { key: 'ja',    label: '日本語' },
];

const I18nForm = ({ label, fieldName, value = {}, onChange, multiline = false, rows = 3 }) => {
  const [activeLang, setActiveLang] = useState('en');

  const handleChange = (e) => {
    onChange({ ...value, [activeLang]: e.target.value });
  };

  const inputStyle = {
    width: '100%',
    border: '1px solid #e2e8f0',
    borderRadius: '0 0 6px 6px',
    padding: '8px 10px',
    fontSize: '13px',
    color: '#334155',
    outline: 'none',
    fontFamily: 'system-ui, sans-serif',
    boxSizing: 'border-box',
    background: '#fff'
  };

  return (
    <div style={{ marginBottom: '14px' }}>
      <label style={{ display: 'block', fontSize: '12px', fontWeight: 600, color: '#475569', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.4px' }}>
        {label}
      </label>
      {/* Language tabs */}
      <div style={{ display: 'flex', borderBottom: '1px solid #e2e8f0' }}>
        {LANGS.map(lang => (
          <button
            key={lang.key}
            type="button"
            onClick={() => setActiveLang(lang.key)}
            style={{
              padding: '5px 12px',
              fontSize: '11px',
              fontWeight: activeLang === lang.key ? 700 : 400,
              color: activeLang === lang.key ? '#3b82f6' : '#64748b',
              background: 'transparent',
              border: 'none',
              borderBottom: activeLang === lang.key ? '2px solid #3b82f6' : '2px solid transparent',
              cursor: 'pointer'
            }}
          >
            {lang.label}
            {value[lang.key] ? ' ✓' : ''}
          </button>
        ))}
      </div>
      {/* Input */}
      {multiline ? (
        <textarea
          value={value[activeLang] || ''}
          onChange={handleChange}
          rows={rows}
          style={{ ...inputStyle, resize: 'vertical' }}
        />
      ) : (
        <input
          type="text"
          value={value[activeLang] || ''}
          onChange={handleChange}
          style={inputStyle}
        />
      )}
    </div>
  );
};

export default I18nForm;
